import { DatePicker } from '@fukuri-admins/ui/common/Form/FormItems/DatePicker';
import { TimeInput } from '@fukuri-admins/ui/common/Form/FormItems/TimeInput';
import styles from './styles.module.scss';

type Props = {
  /** 選択中の日付 */
  scheduledDate?: Date;
  /** 選択中の時刻（"HH:mm" 形式） */
  scheduledTime?: string;
  /** フィールドの非活性状態 */
  disabled?: boolean;
  /** 日付変更ハンドラ */
  onDateChange: (date: Date | undefined) => void;
  /** 時刻変更ハンドラ */
  onTimeChange: (time: string) => void;
  /** 日付フィールドのエラーメッセージ */
  dateError?: string;
  /** 時刻フィールドのエラーメッセージ */
  timeError?: string;
};

/**
 * 予約投稿の日付・時刻入力をまとめた dumb コンポーネント。
 * scheduledDate（DatePicker）と scheduledTime（TimeInput）を横並びで表示する。
 * RHF に依存しない。フォーム統合には ScheduledDateTimeFieldController を使用すること。
 */
export const ScheduledDateTimeField: React.FC<Props> = ({
  scheduledDate,
  scheduledTime,
  disabled,
  onDateChange,
  onTimeChange,
  dateError,
  timeError,
}) => (
  <>
    <div className={styles.dateTimeRow}>
      <DatePicker
        value={scheduledDate}
        onChange={onDateChange}
        disabled={disabled}
        fromDate={new Date()}
      />
      <TimeInput value={scheduledTime ?? ''} onChange={onTimeChange} disabled={disabled} />
    </div>
    {dateError && <p className={styles.errorText}>{dateError}</p>}
    {timeError && <p className={styles.errorText}>{timeError}</p>}
  </>
);
